<template lang="pug">
  main.main.main_request-success
    header.main__header
      h1.main__title {{ $t('requestSuccess.title') }}
      h2.main__subtitle Остались вопросы? Позвоните нам по номеру
        a.main__phone(:href="'tel:' + parsePhone($t('base.phone'))") {{ $t('base.phone') }}
    .main__container
      .main__content
        strong.main__trekking {{ $t('requestSuccess.trekking') }}
          span {{ trackingNumber }}
        .main__button
          router-link.button(:to='{ path: `/tracking`, query: {tn: trackingNumber} }') {{ $t('requestSuccess.button') }}
        p.main__text {{ $t('requestSuccess.text') }}

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Request_Success',
  computed: {
    ...mapGetters({
      trackingNumber: 'getTrackingNumber'
    })
  },
  methods: {
    parsePhone (string) {
      return string.replace(/[^+0-9]/g, '')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Request_Success.vue